<template>
  <div>
    <header class="navbar">
      <div>
        <nuxt-link
          :to="{ name: 'index' }"
          class="text-2xl no-underline text-grey-darkest hover:text-blue-dark"
        >
          familymeyer.ch
        </nuxt-link>
      </div>

      <div class="flex-grow"></div>
      <!-- {{ auth }} -->

      <div id="teleport"></div>

      <template v-if="auth.loggedIn">
        {{ auth.user?.name }}
        <nuxt-link class="anchor" :to="{ name: 'auth-logout' }">
          Logout
        </nuxt-link>
      </template>
    </header>
    <main>
      <slot name="default"></slot>
    </main>
  </div>
</template>

<script lang="ts" setup>
const auth = useAuth();
</script>

<style lang="postcss">
body {
  @apply bg-gray-200;
}

.navbar {
  @apply sticky top-0;
  @apply flex gap-2 flex-col py-4 px-6 bg-white shadow w-full;
  @apply sm:flex-row sm:text-left sm:justify-between sm:items-baseline;
}

/* .container is a tailwind class */
.container {
  @apply mx-auto my-4;
}

.page-enter-active,
.page-leave-active {
  @apply transition ease-out;
}

.page-enter,
.page-leave-to {
  @apply opacity-0;
}

.fade-enter-active,
.fade-leave-active {
  @apply transition;
}

.fade-enter,
.fade-enter-from,
.fade-leave-to {
  @apply opacity-0;
}

.fade-move {
  @apply transition;
}

.anchor {
  @apply underline hover:no-underline hover:text-blue-400;
}
</style>
